module.exports = __webpack_public_path__ + "static/media/Brovka_PU.566e1fef.jpg";